import classNames from 'classnames'

type TimelineStepProps = {
  title: string
  description: string
  activated: boolean
  active: boolean
}

const TimelineStep = ({ title, activated, active }: TimelineStepProps) => {
  const circleClass = classNames(
    'w-7 h-7 transition transition-all relative bright:bg-white light:bg-gray-700 black:bg-black rounded-full',
    {
      'text-blue scale-125': active,
    },
  )

  const innerCircleClass = classNames(
    'transition-all bg-current absolute w-full h-full inset-0 rounded-full',
    {
      'scale-0': !activated && !active,
      'scale-50': activated,
      'scale-100': active,
    },
  )

  const colorClass = classNames('black:text-white', {
    'text-black/40': !active && !activated,
  })

  const titleClass = classNames(
    'hidden lg:block transition-all absolute bottom-10 -translate-x-[calc(50%-(1.75rem/2))]',
    {
      'text-2xl -translate-y-4': active,
    },
  )

  return (
    <div className={colorClass}>
      <div className={titleClass}>{title}</div>
      <div className={circleClass}>
        <div className="transition-all rounded-full border-4 border-current box-border absolute inset-0"></div>
        <div className={innerCircleClass}></div>
      </div>
    </div>
  )
}

export default TimelineStep
